export default __webpack_public_path__ + "images/imagite-high-flag.svg";